import * as React from "react";

import { type VariantProps, tv } from "tailwind-variants";

const inputVariants = tv({
  // "ring-offset-background disabled:bg-muted-foreground/10 disabled:placeholder:text-muted-foreground/50 disabled:border-muted-foreground/50"
  base: "relative flex items-center bg-transparent px-2 accent-brand-primary transition-all focus:border-aubergine-perl-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-secondary/75 focus-visible:ring-offset-2 disabled:pointer-events-none",
  variants: {
    variant: {
      outline: "",
    },
    color: {
      default: "",
      surface: "",
      success: "",
      error: "",
      warning: "",
      info: "",
    },
    rounded: {
      none: "rounded-none",
      sm: "rounded-sm",
      md: "rounded-md",
      lg: "rounded-lg",
      xl: "rounded-xl",
      "2xl": "rounded-2xl",
    },
    size: {
      sm: "h-7 text-xs",
      md: "h-9 text-sm",
      lg: "h-10 text-sm",
    },
  },
  compoundVariants: [
    /** START outline/[color] */
    {
      variant: "outline",
      color: "default",
      class:
        "text-foreground/90 border border-solid border-zinc-400/60 bg-transparent placeholder:text-zinc-400/60 hover:border-zinc-400 hover:placeholder:text-zinc-400",
    },
    {
      variant: "outline",
      color: "surface",
      class:
        "text-foreground border border-solid border-zinc-400/60 placeholder:text-zinc-400/60 hover:border-zinc-400 hover:placeholder:text-zinc-400",
    },
    {
      variant: "outline",
      color: "success",
      class:
        "text-success/75 border-success-light/75 hover:border-success-light placeholder:text-success-light/75 hover:placeholder:text-success-light border",
    },
    {
      variant: "outline",
      color: "info",
      class:
        "text-info/75 border-info-light/75 hover:border-info-light placeholder:text-info-light/75 hover:placeholder:text-info-light border",
    },
    {
      variant: "outline",
      color: "warning",
      class:
        "text-warning/75 border-warning-light/75 hover:border-warning-light placeholder:text-warning-light/75 hover:placeholder:text-warning-light border",
    },
    {
      variant: "outline",
      color: "error",
      class:
        "border-text-red-700/75 hover:border-text-red-700 border text-red-700/75 placeholder:text-red-700/75 hover:placeholder:text-red-700",
    },
    /** END outline/[color] */
  ],
  defaultVariants: {
    variant: "outline",
    color: "default",
    size: "md",
    rounded: "2xl",
  },
});

type InputVariantsProps = VariantProps<typeof inputVariants>;

type InputProps = React.ComponentPropsWithRef<"input"> & InputVariantsProps;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant, color, size, rounded, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        className={inputVariants({ variant, color, size, rounded, className })}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input, inputVariants };
export type { InputProps, InputVariantsProps };
